var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2222",
    "data-name": "Rectangle 2222",
    width: 70,
    height: 70,
    transform: "translate(-2 -1.736)",
    fill: "#ffbd00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10360",
    "data-name": "Group 10360",
    transform: "translate(2 1.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10359",
    "data-name": "Group 10359",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27733",
    "data-name": "Path 27733",
    d: "M33.132,0A33.132,33.132,0,1,0,66.264,33.132,33.139,33.139,0,0,0,33.132,0m0,60.742a27.61,27.61,0,1,1,27.61-27.61,27.615,27.615,0,0,1-27.61,27.61",
    fill: "#ffbd00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27734",
    "data-name": "Path 27734",
    d: "M26.241,28.985,13.772,21.509v-15a2.761,2.761,0,0,0-5.522,0V23.077a3,3,0,0,0,1.336,2.374l13.8,8.283a2.769,2.769,0,1,0,2.849-4.749",
    transform: "translate(22.121 10.055)",
    fill: "#ffbd00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon1);
export default __webpack_public_path__ + "static/media/social_icon1.f476970aafc46da93d752fb39a5a4e18.svg";
export { ForwardRef as ReactComponent };